module.exports = __webpack_public_path__ + "img/sjs-5.5758b395.png";